import { SortingHeaderButton } from '@/components/ui/DataTable/SortingHeaderButton'
import { RestSchemas } from '@/contexts/QueryProvider'
import { ColumnDef } from '@tanstack/react-table'
import clsx from 'clsx'
import { RowActionsMenu } from './RowActionsMenu'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { NumberBadge } from '@/components/ui/DataTable/NumberBadge'
import { Avatar, AvatarFallback } from '@/components/shadcn/avatar'
import { getInitials } from '@/lib/utils'
import { ProjectIcon } from '@/const'

type MessagesProjectsOrganisationProject = RestSchemas['Messages.Projects.OrganisationProject']

export const columns: ColumnDef<MessagesProjectsOrganisationProject>[] = [
  {
    id: 'name',
    accessorKey: 'name',
    header: ({ column }) => <SortingHeaderButton column={column}>Name</SortingHeaderButton>,
    cell: ({ row }) => (
      <div className="flex items-center gap-x-2">
        <ProjectIcon className="size-4 text-muted-foreground" />
        {row.original.name}
      </div>
    ),
    sortingFn: (rowA, rowB) => rowA.original.name.localeCompare(rowB.original.name),
  },
  {
    id: 'Workspaces',
    accessorKey: 'workspaceCount',
    header: ({ column }) => <SortingHeaderButton column={column}>Workspaces</SortingHeaderButton>,
    cell: ({ row }) => <NumberBadge value={row.original.workspaceCount} />,
  },
  {
    id: 'Administrators',
    accessorKey: 'administrators',
    header: 'Administrators',
    cell: ({ row }) => (
      <div className="flex -space-x-2">
        {row.original.administrators.map((a, i) => (
          <TooltipButton key={a.userId} tooltip={a.name}>
            <Avatar className="ring-2 ring-background">
              <AvatarFallback
                className={clsx(
                  'bg-accent text-accent-foreground',
                  i % 2 !== 0 && 'bg-secondary text-secondary-foreground'
                )}
              >
                {getInitials(a.name)}
              </AvatarFallback>
            </Avatar>
          </TooltipButton>
        ))}
      </div>
    ),
  },
  {
    id: 'Leaders',
    accessorKey: 'leaders',
    header: 'Leaders',
    cell: ({ row }) => (
      <div className="flex -space-x-2">
        {row.original.leaders.map((a, i) => (
          <TooltipButton key={a.userId} tooltip={a.name}>
            <Avatar className="ring-2 ring-background">
              <AvatarFallback
                className={clsx(
                  'bg-accent text-accent-foreground',
                  i % 2 !== 0 && 'bg-secondary text-secondary-foreground'
                )}
              >
                {getInitials(a.name)}
              </AvatarFallback>
            </Avatar>
          </TooltipButton>
        ))}
      </div>
    ),
  },
  {
    id: 'actions',
    // header: 'Actions',
    cell: ({ row }) => (
      <div className="flex justify-end pr-5">
        <RowActionsMenu project={row.original} />
      </div>
    ),
  },
]
